import PropTypes from "prop-types";
import "./node.css";

const propTypes = {
  nodeData: PropTypes.object.isRequired
};

const MyNode = ({ nodeData }) => {
  const selectNode = () => {
    // eslint-disable-next-line no-alert
    alert(`Hi All. I'm ${nodeData.name}. I'm a ${nodeData.title}.`);
  };

  return (
    <div onClick={selectNode}>
      <div className="fullname">{nodeData.name}</div>
      <div className="position">{nodeData.title}</div>
    </div>
  );
};

MyNode.propTypes = propTypes;

export default MyNode;
